/* ==========================================================================
   MENILOR — comportamiento propio (vanilla, sin librerías)
   ========================================================================== */

(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Entradas al hacer scroll ---------- */
  function initReveals() {
    var items = document.querySelectorAll('.mn-reveal:not(.mn-visible)');
    if (!items.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('mn-visible');
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('mn-visible');
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    items.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- Cifras que cuentan ---------- */
  function initCifras() {
    var nums = document.querySelectorAll('[data-mn-cuenta]');
    if (!nums.length) return;

    function pinta(el, valor) {
      var dec = parseInt(el.getAttribute('data-mn-decimales') || '0', 10);
      var txt = dec > 0 ? valor.toFixed(dec).replace('.', ',') : Math.round(valor).toString();
      el.textContent = (el.getAttribute('data-mn-antes') || '') + txt + (el.getAttribute('data-mn-despues') || '');
    }

    function anima(el) {
      var destino = parseFloat(el.getAttribute('data-mn-cuenta'));
      if (isNaN(destino)) return;
      if (reduce) { pinta(el, destino); return; }

      var inicio = null;
      var dur = 1500;

      function paso(t) {
        if (inicio === null) inicio = t;
        var p = Math.min((t - inicio) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        pinta(el, destino * eased);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      nums.forEach(function (el) { anima(el); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        anima(entry.target);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    nums.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- Cuenta atrás ---------- */
  function initContadores() {
    var cajas = document.querySelectorAll('[data-mn-contador]');
    if (!cajas.length) return;

    cajas.forEach(function (caja) {
      var limite;
      var minutos = parseInt(caja.getAttribute('data-mn-duracion') || '0', 10);

      if (minutos > 0) {
        // Cuenta atrás por visita: arranca cuando la persona entra y se guarda
        // en la SESIÓN del navegador. Así no se reinicia al recargar ni al
        // navegar entre páginas, pero sí vuelve a empezar en una visita nueva
        // (otra pestaña, otro día) en lugar de quedarse en cero para siempre.
        var clave = caja.getAttribute('data-mn-clave') || 'mn-cuenta';
        var almacen = null;
        try {
          almacen = window.sessionStorage;
          almacen.setItem('mn-test', '1');
          almacen.removeItem('mn-test');
        } catch (e) {
          almacen = null;
        }

        var guardado = null;
        if (almacen) {
          try { guardado = almacen.getItem(clave); } catch (e) { guardado = null; }
        }

        limite = guardado ? parseInt(guardado, 10) : NaN;

        var restante = limite - Date.now();
        // Si no hay nada guardado, si el valor es inválido, si ya venció o si
        // por lo que sea quedara más tiempo del configurado, empezamos de cero.
        if (isNaN(limite) || restante <= 0 || restante > minutos * 60000) {
          limite = Date.now() + minutos * 60000;
          if (almacen) {
            try { almacen.setItem(clave, String(limite)); } catch (e) {}
          }
        }

        // Limpieza del sistema anterior, que guardaba en localStorage y dejaba
        // el reloj clavado en cero entre visitas.
        try { window.localStorage.removeItem(clave); } catch (e) {}
      } else {
        limite = new Date(caja.getAttribute('data-mn-contador').replace(/-/g, '/')).getTime();
      }

      if (isNaN(limite)) return;

      var dd = caja.querySelector('[data-mn-dias]');
      var hh = caja.querySelector('[data-mn-horas]');
      var mm = caja.querySelector('[data-mn-minutos]');
      var ss = caja.querySelector('[data-mn-segundos]');
      var fin = caja.querySelector('[data-mn-fin]');
      var reloj = caja.querySelector('[data-mn-reloj]');

      function dosDigitos(n) { return n < 10 ? '0' + n : '' + n; }

      function tic() {
        var resta = limite - Date.now();

        if (resta <= 0) {
          if (reloj) reloj.style.display = 'none';
          if (fin) fin.hidden = false;
          clearInterval(timer);
          return;
        }

        var s = Math.floor(resta / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var g = s % 60;

        if (dd) dd.textContent = dosDigitos(d);
        if (hh) hh.textContent = dosDigitos(h);
        if (mm) mm.textContent = dosDigitos(m);
        if (ss) ss.textContent = dosDigitos(g);
      }

      tic();
      var timer = setInterval(tic, 1000);
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mn-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (gal) {
      var principal = gal.querySelector('[data-mn-principal]');
      var minis = gal.querySelectorAll('[data-mn-mini]');
      if (!principal || !minis.length) return;

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-mn-src');
          var alt = mini.getAttribute('data-mn-alt') || '';
          if (!src) return;
          principal.src = src;
          principal.alt = alt;
          minis.forEach(function (m) { m.classList.remove('mn-activa'); });
          mini.classList.add('mn-activa');
        });
      });
    });
  }

  /* ---------- Variantes de producto ---------- */
  function initVariantes() {
    var formularios = document.querySelectorAll('[data-mn-variantes]');
    if (!formularios.length) return;

    formularios.forEach(function (raiz) {
      var datos = raiz.querySelector('[data-mn-variantes-json]');
      if (!datos) return;

      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      if (!variantes || !variantes.length) return;

      var selects = raiz.querySelectorAll('[data-mn-opcion]');
      var campoId = raiz.querySelector('[data-mn-id-variante]');
      var precio = raiz.querySelector('[data-mn-precio]');
      var precioAntes = raiz.querySelector('[data-mn-precio-antes]');
      var boton = raiz.querySelector('[data-mn-boton]');
      var agotado = raiz.querySelector('[data-mn-agotado]');
      if (!selects.length || !campoId) return;

      function actualiza() {
        var elegidas = [];
        selects.forEach(function (s) { elegidas.push(s.value); });

        var v = null;
        for (var i = 0; i < variantes.length; i++) {
          var coincide = true;
          for (var j = 0; j < elegidas.length; j++) {
            if (variantes[i].options[j] !== elegidas[j]) { coincide = false; break; }
          }
          if (coincide) { v = variantes[i]; break; }
        }

        if (!v) return;

        campoId.value = v.id;
        if (precio) precio.textContent = v.precio;
        if (precioAntes) {
          if (v.precio_antes) { precioAntes.textContent = v.precio_antes; precioAntes.hidden = false; }
          else { precioAntes.hidden = true; }
        }
        if (boton) {
          boton.disabled = !v.disponible;
          boton.textContent = v.disponible ? boton.getAttribute('data-mn-texto') : boton.getAttribute('data-mn-texto-agotado');
        }
        if (agotado) agotado.hidden = v.disponible;
      }

      selects.forEach(function (s) { s.addEventListener('change', actualiza); });
    });
  }

  /* ---------- Marquesina de opiniones: duplicar para bucle continuo ---------- */
  function initCintas() {
    var cintas = document.querySelectorAll('[data-mn-cinta]');
    if (!cintas.length) return;

    cintas.forEach(function (cinta) {
      if (cinta.getAttribute('data-mn-duplicada') === 'si') return;
      var hijos = Array.prototype.slice.call(cinta.children);
      hijos.forEach(function (hijo) {
        var copia = hijo.cloneNode(true);
        copia.setAttribute('aria-hidden', 'true');
        cinta.appendChild(copia);
      });
      cinta.setAttribute('data-mn-duplicada', 'si');
    });
  }

  /* ---------- Oferta al agregar al carrito (upsell) ---------- */
  function initUpsell() {
    var modal = document.querySelector('[data-mn-upsell]');
    var form = document.querySelector('.mn-prod form[action*="/cart/add"]');
    if (!modal || !form) return;
    if (form.getAttribute('data-mn-upsell-listo') === 'si') return;
    form.setAttribute('data-mn-upsell-listo', 'si');

    var boton = form.querySelector('[data-mn-boton]');
    var idOferta = modal.getAttribute('data-mn-variante-oferta');
    var codigo = modal.getAttribute('data-mn-codigo');

    function irAlCarrito() {
      if (codigo) {
        window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=/cart';
      } else {
        window.location.href = '/cart';
      }
    }

    function abrir() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      // Forzamos un reflow para que la transición arranque, sin depender de
      // requestAnimationFrame (que no corre si la pestaña está en segundo plano).
      void modal.offsetWidth;
      modal.classList.add('mn-up--visible');
      var si = modal.querySelector('[data-mn-up-si]');
      if (si) si.focus();

      // Seguro: si la transición no llega a arrancar (pestaña en segundo
      // plano, navegador raro), forzamos el estado final para que nunca quede
      // una ventana invisible bloqueando la pantalla.
      setTimeout(function () {
        var caja = modal.querySelector('.mn-up__caja');
        if (caja && getComputedStyle(caja).opacity !== '1') {
          caja.style.opacity = '1';
          caja.style.transform = 'none';
        }
      }, 500);
    }

    function cerrar() {
      modal.classList.remove('mn-up--visible');
      document.body.style.overflow = '';
      setTimeout(function () { modal.hidden = true; }, 260);
    }

    function textoCargando(el, texto) {
      if (!el) return;
      el.disabled = true;
      el.dataset.mnPrevio = el.textContent;
      el.textContent = texto;
    }

    function restaurar(el) {
      if (!el) return;
      el.disabled = false;
      if (el.dataset.mnPrevio) el.textContent = el.dataset.mnPrevio;
    }

    var rendirse = false;

    function alEnviar(e) {
      if (rendirse) return; // dejamos que el formulario haga su envío normal
      var idActual = form.querySelector('[name=id]');
      if (!idActual) return;

      e.preventDefault();
      textoCargando(boton, 'Agregando…');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idActual.value), quantity: 1 }] })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          restaurar(boton);
          abrir();
        })
        .catch(function () {
          // Si algo falla, el formulario vuelve a comportarse como siempre.
          restaurar(boton);
          rendirse = true;
          form.submit();
        });
    }

    form.addEventListener('submit', alEnviar);

    modal.querySelectorAll('[data-mn-up-cerrar]').forEach(function (el) {
      el.addEventListener('click', cerrar);
    });

    var no = modal.querySelector('[data-mn-up-no]');
    if (no) no.addEventListener('click', irAlCarrito);

    var si = modal.querySelector('[data-mn-up-si]');
    if (si) {
      si.addEventListener('click', function () {
        textoCargando(si, 'Agregando…');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idOferta), quantity: 1 }] })
        })
          .then(function () { irAlCarrito(); })
          .catch(function () { irAlCarrito(); });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) cerrar();
    });
  }

  function init() {
    initReveals();
    initCifras();
    initContadores();
    initGaleria();
    initVariantes();
    initCintas();
    initUpsell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* El editor de Shopify recarga secciones sueltas: re-inicializar */
  document.addEventListener('shopify:section:load', init);
})();
